var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nvd3-line bar-chart text-center",attrs:{"id":_vm.barchart_id,"data-x-grid":"false"}},[_c('svg')])}
var staticRenderFns = []

export { render, staticRenderFns }